<template>
    <div>
        <h3>Schreiben wurde an Sie gesendet.</h3>
        <p>Wir haben das von Ihnen erstellte Widerrufsschreiben an die von Ihnen angegebene E-Mail-Adresse gesendet. Sie müssen das Schreiben nur noch ausdrucken, unterschreiben und versenden. <br/>
        Bitte beachten Sie dabei aber vorab die Ihnen mit dem Schreiben überlassenen Hinweise.
        </p>

        <div id="error" v-if="error">
            <div class="alert-box alert">
                <h3>Fehler</h3>
                <p>Leider ist ein Fehler aufgetreten und Ihre Daten konnten nicht an uns übermittelt werden. Bitte kontaktieren Sie uns unter
                    <a href="mailto:info@ratis.de">info@ratis.de</a>.
                </p>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    props: {
    },

    data() {
        return {
            error: false,
            submitting: false,
            submitted: false
        };
    },
    methods: {
    }
};
</script>


<style>
</style>